<!--
 * @Description: 计划管理页面
 * @Author: Tina
 * @Date: 2022-12-16 10:32:21
 * @LastEditors: Tina
 * @LastEditTime: 2023-01-31 17:03:00
 -->

<template>
  <div class="sale-plan" @keyup.enter="enterSearch">
    <el-form ref="form" :model="form" inline class="table-search-bar" label-width="70px">
      <el-form-item label="模板状态" prop="status">
        <el-select v-model="form.status">
          <el-option
            v-for="item in statusArr"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="模板名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入模板名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
        <el-button type="primary" @click="handleAdd" v-permission="'0100601'">新增计划模板</el-button>
        <el-button type="primary" @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="list"
      style="width: 100%"
      tooltip-effect="light">
      <el-table-column
        prop="name"
        label="模板名称"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="status"
        label="模板状态"
        :formatter="formatStatus"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="createPerson"
        label="创建人"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="updateTime"
        label="修改时间"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="updatePerson"
        label="修改人"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        label="操作"
        width="200px">
        <template slot-scope="scope">
          <el-button @click="handleView(scope.row)">查看</el-button>
          <el-button @click="handleEdit(scope.row)" v-permission="'0100602'">修改</el-button>
          <!-- <el-button type="danger" @click="handleDelete(scope.row)" v-permission="'0100102'">删除</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :page-sizes="[10, 20, 50, 100]"
      :page-size="listState.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="listState.total"
      :current-page="listState.pageNo"
      background
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange">
    </el-pagination>
    <add-or-edit-dialog :show.sync="dialogVisible" :info="dialogInfo"></add-or-edit-dialog>
    <info-view-dialog :show.sync="infoViewDialogVisible" :info="infoViewDialogInfo"></info-view-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AddOrEditDialog from './addOrEditDialog'
import InfoViewDialog from './infoViewDialog'

export default {
  name: 'salePlan',
  components: { InfoViewDialog, AddOrEditDialog },
  data () {
    return {
      form: {
        name: '',
        status: ''
      },
      statusArr: [
        { value: '', label: '全部' },
        { value: 1, label: '未使用' },
        { value: 0, label: '使用中' }
      ],
      dialogVisible: false,
      dialogInfo: {},
      infoViewDialogVisible: false,
      infoViewDialogInfo: {}
    }
  },
  computed: {
    ...mapGetters({ list: 'getSalePlanManageList', listState: 'getSalePlanManageListState' })
  },
  methods: {
    ...mapActions(['getSalePlanManageList', 'getSalePlanManageInfo']),
    enterSearch (e) { // 回车搜索
      if (e.target.form && e.target.nodeName === 'INPUT') {
        this.handleSearch()
      }
    },
    // 搜索
    handleSearch () {
      const params = { ...this.form, pageNo: 1 }
      this.getSalePlanManageList(params)
    },
    // 查询表单，表格重置
    handleReset () {
      this.$refs.form.resetFields()
      this.handleSearch()
    },
    // 分页条数变更
    handleSizeChange (val) {
      this.getSalePlanManageList({ pageSize: val, pageNo: 1 })
    },
    // 分页跳转
    handleCurrentChange (val) {
      this.getSalePlanManageList({ pageNo: val })
    },
    // 查看
    handleView (row) {
      this.getSalePlanManageInfo({ id: row.id }).then(res => {
        this.infoViewDialogInfo = res
        this.infoViewDialogVisible = true
      })
    },
    // 删除
    // handleDelete (row) {
    //   this.$confirm('是否删除该销售计划？', '删除提醒', {
    //     confirmButtonText: '确认',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(() => {
    //     this.deleteSalePlan({ id: row.id, status: row.status }).then(res => {
    //       this.getSalePlanManageList({ pageNo: 1 })
    //     })
    //   }).catch(() => {})
    // },
    // 新增
    handleAdd () {
      this.dialogInfo = {}
      this.dialogVisible = true
    },
    // 编辑
    handleEdit (row) {
      this.getSalePlanManageInfo({ id: row.id }).then(res => {
        this.dialogInfo = { ...res, id: row.id }
        this.dialogVisible = true
      })
    },
    formatMemberType (row) {
      const map = {
        1: '分销',
        2: '贸易',
        3: '终端',
        4: '预留'
      }
      return map[row.custom] || '-'
    },
    formatStatus (row) {
      const status = this.$lodash.find(this.statusArr, { value: row.status }) || {}
      return status.label
    }
  },
  mounted () {
    this.handleSearch()
  }
}
</script>

<style scoped>
.upload-btn{
  display: inline-block;
  margin: 0 10px;
}
</style>
